var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAppearanceIcon = function SvgAppearanceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.722 2.428a.972.972 0 00-1.032-.4A10.101 10.101 0 002 11.866C2 17.452 6.548 22 12.134 22c4.677 0 8.722-3.161 9.838-7.69a.972.972 0 00-.4-1.032.972.972 0 00-1.103.013 6.978 6.978 0 01-4.051 1.297 7.012 7.012 0 01-7.006-7.006c0-1.458.452-2.858 1.297-4.051a.972.972 0 00.013-1.103z",
    fill: "url(#AppearanceIcon_svg__jr1ceecxea)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "AppearanceIcon_svg__jr1ceecxea",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.00248 15.5529 -16.1767 7.28333 4.997 6.447)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgAppearanceIcon;